import { CSS } from '@grupoboticario/flora-react'

export const fullWidthCss: CSS = {
  width: '100%'
}

export const responsiveButtonCss: CSS = {
  width: '100%',
  '@desktop': { width: 'auto' }
}

export const justificationNoteCss: CSS = {
  marginTop: 8,
  alignSelf: 'end',
  color: '$nonInteractiveAuxiliar'
}
